module.exports = __webpack_public_path__ + "img/ic_roof_type.8ca0482b.svg";